import { render } from "./Stocks.vue?vue&type=template&id=0fa76ef0&scoped=true&ts=true"
import script from "./Stocks.vue?vue&type=script&lang=ts"
export * from "./Stocks.vue?vue&type=script&lang=ts"

import "./Stocks.vue?vue&type=style&index=0&id=0fa76ef0&scoped=true&lang=css"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa76ef0"]])

export default __exports__